module.exports = __webpack_public_path__ + "static/media/snapback-cover.0c61bcf3.webp";